module.exports = __webpack_public_path__ + "magnifier.07371979aa9ca2e9f8a8ec78216b06bd.svg";


//////////////////
// WEBPACK FOOTER
// ./web_modules/trustar/img/magnifier.svg
// module id = 1655
// module chunks = 39